var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "-mx-3" }, [
    _c(
      "div",
      { staticClass: "text-center mx-auto" },
      _vm._l(
        _vm.$store.state.data.Steps[_vm.$store.state.activeStep].Options,
        function(option, index) {
          return _c(
            "square-option",
            {
              key: option.Id,
              attrs: { isActive: _vm.isActiveStep(index) },
              nativeOn: {
                click: function($event) {
                  var _obj
                  _vm.setSelectedTile(index)
                  _vm.setUserInput(
                    ((_obj = {}),
                    (_obj[
                      _vm.$store.state.data.Steps[
                        _vm.$store.state.activeStep
                      ].SalesforcePropertyKey
                    ] = option.SalesforcePropertyValue),
                    _obj)
                  )
                  _vm.setNextStep()
                }
              },
              scopedSlots: _vm._u(
                [
                  option.Description == "" && option.Title
                    ? {
                        key: "text-below",
                        fn: function() {
                          return [_vm._v(_vm._s(option.Title))]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _c("div", { staticClass: "p-3 text-left" }, [
                _c("div", { staticClass: "aspect-w-1 aspect-h-1" }, [
                  _c("img", {
                    staticClass: "w-full h-full object-cover",
                    attrs: { src: option.ImageUrl, alt: "image" }
                  })
                ]),
                _vm._v(" "),
                option.Description != "" && option.Title
                  ? _c("p", { staticClass: "text-lg mb-2 md:text-xl mt-3" }, [
                      _vm._v(
                        "\n          " + _vm._s(option.Title) + "\n        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                option.Description
                  ? _c("p", { staticClass: "text-xs md:text-base mt-0" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(option.Description) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        }
      ),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }